import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Moon, Sun, Menu, X } from "lucide-react";

const links = [
  { label: "About", href: "#about" },
  { label: "Experience", href: "#experience" },
  { label: "Work", href: "#work" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = ({ dark, toggleTheme, simple = false }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-[500] transition-colors duration-300 ${
        scrolled
          ? "border-b border-[var(--border)] bg-[var(--bg)]/70 backdrop-blur-xl"
          : "border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-[1600px] items-center justify-between px-5 py-4 sm:px-10">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-display text-lg font-black uppercase tracking-tighter"
        >
          Bushra Paracha<span className="text-[var(--accent)]">.</span>
        </Link>

        {simple ? (
          <div className="flex items-center gap-6">
            <Link
              to="/"
              data-testid="nav-back"
              className="link-underline font-mono text-xs uppercase tracking-[0.2em] text-[var(--text-2)] transition-colors hover:text-[var(--text)]"
            >
              ← Portfolio
            </Link>
            <button
              data-testid="theme-toggle"
              onClick={toggleTheme}
              aria-label="Toggle theme"
              className="rounded-full border border-[var(--border)] p-2 transition-colors hover:border-[var(--accent)]"
            >
              {dark ? <Sun size={16} /> : <Moon size={16} />}
            </button>
          </div>
        ) : (
        <div className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="link-underline font-mono text-xs uppercase tracking-[0.2em] text-[var(--text-2)] transition-colors hover:text-[var(--text)]"
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="theme-toggle"
            onClick={toggleTheme}
            aria-label="Toggle theme"
            className="rounded-full border border-[var(--border)] p-2 transition-colors hover:border-[var(--accent)]"
          >
            {dark ? <Sun size={16} /> : <Moon size={16} />}
          </button>
        </div>
        )}

        {!simple && (
        <div className="flex items-center gap-3 md:hidden">
          <button
            data-testid="theme-toggle-mobile"
            onClick={toggleTheme}
            aria-label="Toggle theme"
            className="rounded-full border border-[var(--border)] p-2"
          >
            {dark ? <Sun size={16} /> : <Moon size={16} />}
          </button>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
            className="rounded-full border border-[var(--border)] p-2"
          >
            {open ? <X size={16} /> : <Menu size={16} />}
          </button>
        </div>
        )}
      </nav>

      {!simple && open && (
        <div className="flex flex-col gap-1 border-t border-[var(--border)] bg-[var(--bg)] px-5 py-4 md:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="py-3 font-display text-2xl font-bold uppercase tracking-tight"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
